/*eslint-disable*/
import React, { useEffect, useState, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";
import { useNavigate, useLocation } from "react-router-dom";
import GridItem from "components/Grid/GridItem.js";
import { offices, STYLES } from "config";
import GridContainer from "components/Grid/GridContainer.js";
import moment from "moment";
import {
    Row,
    Col,
    Label,
    CardBody,
    Card,
    CardHeader,
    CardFooter,
    CardTitle,
    FormGroup,
    Input,
    FormText,
    Button,
} from "reactstrap";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import CreateAreaDashboardModal from "components/CreateAreaDashboardModal";
import CreateRegionModal from "components/CreateRegionModal";
import CustomDropDownPicker from "components/CustomDropDownPicker";

import AddBoxRounded from "@material-ui/icons/AddBoxRounded";
import { FirebaseContext } from "common";

const regionManagement = () => {
    const { api } = useContext(FirebaseContext);
    const {
        createBranch,
        clearBranchErrors,
        fetchBranchesEnquiries,
        fetchAllBranchListings,
        updateBranch,
        deleteBranch,
        updateArea,
        deleteArea,
        fetchCities,
        fetchSuburbs,
        updateRegion,
    } = api;


    //console.log(api);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const branchManagementReducer = useSelector((state) => state.branchData);
    const usertypes = useSelector((state) => state.usertypes.userstypes);
    const brokers = useSelector((state) => state.brokers.users);
    const areaData = useSelector((state) => state.areaData);
    const regionData = useSelector((state) => state.regionData);
    const usersdata = useSelector((state) => state.usersdata);
    const cities = useSelector((state) => state.citiesdata.city);
    const suburbs = useSelector((state) => state.citiesdata.suburb);

    const adminsdata = useSelector((state) => state.usersdata.admins);

    // State for modal visibility and form data
    const [brokerList, setBrokerList] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const auth = useSelector((state) => state.auth);
    const [selectedBrokers, setSelectedBrokers] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState([]);
    const [selectedArea, setSelectedArea] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState([]);
    const [selectedRegionAreas, setSelectedRegionAreas] = useState([]);
    const [parsed, setParsed] = useState([]);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isAreaModalOpen, setIsAreaModalOpen] = useState(false);
    const [selectedBranchToDelete, setSelectedBranchToDelete] = useState(null);
    const [selectedAreaToDelete, setSelectedAreaToDelete] = useState(null);
    const [branchList, setBranchList] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [suburbOption, setSuburbOption] = useState([]);
    const [areaTableData, setAreaTableData] = useState([]);

    const [regionDetailsState, setRegionDetailsState] = useState({
        regionName: "",
    });

    const [successMessage, setSuccessMessage] = useState("");

    let areas = areaData.areas;
    const [regions, setRegions] = useState(regionData.regions);

    const branchData = branchManagementReducer.branches;
    const [error, setError] = useState(null);
    const [editRegionData, setEditRegionData] = useState({
        regionId: "",
        regionName: "",
        selectedBranchName: "",
        shareBrokers: [],
        areas: [],
    });
    const [officeData, setBranchData] = useState({
        BranchName: "",
        Province: "",
        manager: "",
        address: "",
        contactInfo: "",
        admin: "",

        // share: auth?.info?.profile?.brokerHomeOffice,
    });

    const provinceOptions = [
        { value: '7', label: 'Eastern Cape' },
        { value: '3', label: 'Free State' },
        { value: '1', label: 'Gauteng' },
        { value: '2', label: 'KwaZulu Natal' },
        { value: '14', label: 'Limpopo' },
        { value: '5', label: 'Mpumalanga' },
        { value: '6', label: 'North West' },
        { value: '8', label: 'Northern Cape' },
        { value: '9', label: 'Western Cape' },
    ];

    const [isCardView, setIsCardView] = useState(true);
    const toggleModal = () => setIsOpen(!isOpen);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setBranchData({ ...officeData, [name]: value });
    };

    const updateDropDown = (id, value) => {

        console.log('id', id)
        console.log('value', value)
        const updatedP24 = { ...editAreaData?.p24, [id]: value };
        setEditAreaData(prevState => ({
            ...prevState,
            p24: updatedP24
        }));
        console.log("updatedP24", updatedP24, `state`, editAreaData);
    };

    const handleBrokerChange = (e) => {
        const selectedValue = e.target.value;
        setSelectedBrokers(selectedValue); // Update selectedBroker
        setBranchData({ ...officeData, manager: selectedValue }); // Sync with officeData.manager
    };

    const handleDeleteClick = (rowData) => {
        setSelectedAreaToDelete(rowData);
        setIsDeleteModalOpen(true);
    };

    const updateAreaDetails = (location, data) => {

        setAreaDetailsState({
            ...areaDetailsState,
            [location]: data.label,
        });
        console.log(`areaDetailsState: ${JSON.stringify(areaDetailsState)}`)
    };

    const addGeoPoint = (suburbId) => {
        let suburb = suburbs.find(sub => sub.id === suburbId)
        console.log('geoPoint', suburb.geoPoint)

        const updatedP24 = { ...editAreaData?.p24, ["geoPoint"]: suburb.geoPoint, suburbId: suburbId };
        setEditAreaData(prevState => ({
            ...prevState,
            p24: updatedP24
        }));
        console.log("updatedP24", updatedP24, `state`, editAreaData);
    };

    const confirmDelete = async () => {
        if (selectedAreaToDelete) {
            try {
                console.log(`In confirm delete: ${JSON.stringify(selectedAreaToDelete)}`)
                await dispatch(
                    deleteArea(selectedAreaToDelete)
                );
                alert("Area deleted successfully!");
                setIsDeleteModalOpen(false);
                setSelectedAreaToDelete(null); // Clear selection
            } catch (error) {
                console.error("Error deleting area:", error);
                alert("Failed to delete area: " + error.message); // Notify user on failure
            }
        }
    };
    //Admin handler
    const handleAdminChange = (e) => {
        const selectedOption = e.target.value;
        setSelectedAdmin(selectedOption);
        setBranchData({ ...officeData, admin: selectedOption }); // Sync with officeData.manager
    };

    // Handle submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        const result = await dispatch(createBranch(officeData));

        if (result.success) {
            alert(result.message);
            toggleModal();
            setBranchData({
                BranchName: "",
                Province: "",
                manager: "",
                address: "",
                contactInfo: "",
                admin: " ",
            });
        }
        if (result.success) {
            alert(result.message);
            toggleModal();
            setBranchData({
                BranchName: "",
                Province: "",
                manager: "",
                address: "",
                contactInfo: "",
                admin: " ",
            });
        }
    };

    const getAreaNames = (passedAreas) => {
        let arr = [];

        if (areaData?.areas && Array.isArray(areaData.areas)) {
            Object.values(passedAreas || []).forEach((areaId) => {
                const area = areaData.areas.find((a) => a.areaId === areaId);
                if (area) {
                    arr.push(area.areaName);
                }
            });
        } else {
            console.error("areaData.areas is not a valid array");
            return [];
        }
        setSelectedRegionAreas(arr);
    }

    //areas button
    const handleAreasClick = (rowData) => {
        getAreaNames(rowData.areas);
        console.log(`selected region areas: ${JSON.stringify(selectedRegionAreas)}`);
        setIsAreaModalOpen(true);
    };

    //Edit button
    const handleEditClick = (rowData) => {
        setSelectedRegion(rowData);
        setEditRegionData({
            regionId: rowData?.regionId,
            regionName: rowData?.regionName,
            selectedBranchName: rowData?.selectedBranchName,
            shareBrokers: rowData?.shareBrokers || [],
            areas: rowData?.areas || [],
        });
        setRegionDetailsState({
            regionName: "",
        })
        setIsEditModalOpen(true);
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();
        dispatch(
            updateRegion(editRegionData)
        );
        alert("Region updated successfully!");
        setIsEditModalOpen(false);
    };

    // const brokerMap = Array.isArray(brokers)
    //     ? brokers.reduce((map, broker) => {
    //         map[broker.id] = `${broker.firstName} ${broker.lastName}`;
    //         return map;
    //     }, {})
    //     : {};

    function concatLocationString(province, city, suburb) {

        if (province === "" && city === "" && suburb === "") {
            //alert("Please enter a province, city and suburb")
            return "";
        }

        let locationString = `South Africa, ${province}, ${city}, ${suburb}`;

        return (
            locationString
        );
    }

    function generateLocationAbbr(city, suburb) {

        if (city === "" && suburb === "") {
            //alert("Please enter a city or suburb to generate an abbreviation.");
            return "";
        }

        let locationAbbr = `${capitalizeFirstLetter(city).slice(
            0,
            3
        )}${capitalizeFirstLetter(suburb).slice(0, 2)}`;

        return (
            locationAbbr
        );
    }

    const capitalizeFirstLetter = (text) => {
        if (!text) return "";
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    };

    useEffect(() => {
        let arr = [];
        if (brokers) {
            console.log("Brokers:", brokers); // Log brokers to verify data
            for (let index = 0; index < brokers.length; index++) {
                const element = brokers[index];

                // Populate the list with all brokers, remove brokerHomeOffice filter
                if (element.brokerHomeOffice === auth?.info?.profile?.adminHomeOffice) {
                    arr.push({
                        value: element.id, // The broker ID (or name if preferred)
                        label: `${element.firstName} ${element.lastName}`, // Broker name
                    });
                }
            }
            setBrokerList(arr.sort((a, b) => a.label.localeCompare(b.label)));
            console.log("Broker List:", arr); // Log broker list to verify population
        }
    }, [brokers]);

    useEffect(() => {
        if (regionData && regionData.regions) {
            setRegions(regionData.regions);
        }
    }, [regionData])

    useEffect(() => {
        if (editRegionData ) {
            console.log(`edit data: ${JSON.stringify(editRegionData)}`)
        }
    }, [editRegionData])

    useEffect(() => {
        if (regionDetailsState.regionName !== "") {
            setEditRegionData(prevState => ({
                ...prevState,
                regionName: regionDetailsState,
            }));
            console.log(`Region Name: ${editRegionData.regionName}`);
        }

    }, [regionDetailsState]);

    useEffect(() => {
        let arr2 = [];

        if (branchData) {
            //console.log("Branch Data:", branchData); // Log branch data to verify data
            for (let index = 0; index < branchData.length; index++) {
                const element = branchData[index];

                console.log(`adminHomeOffive: ${auth?.info?.profile?.adminHomeOffice}`);

                // Populate the list with all branches, remove brokerHomeOffice filter
                if (element.BranchName === auth?.info?.profile?.adminHomeOffice
                    //|| auth?.info?.profile?.Areas[0]?.includes("All Areas")
                ) {
                    arr2.push({
                        value: element.branchId, // The branch ID (or name if preferred)
                        label: `${element.BranchName}`, // Branch name
                    });
                }
            }
            setBranchList(arr2.sort((a, b) => a.label.localeCompare(b.label)));
            console.log("Branch List:", arr2); // Log branch list to verify population
        }
    }, [branchData]);

    const renderAreasModal = () => (
        <Modal
            isOpen={isAreaModalOpen}
            toggle={() => setIsAreaModalOpen(false)}
            centered
        >
            <ModalHeader>
                Areas in region
            </ModalHeader>
            <ModalBody>
                {selectedRegionAreas && Object.keys(selectedRegionAreas).length > 0 ? (
                    <ul>
                        {Object.entries(selectedRegionAreas).map(([key, area]) => (
                            <li key={key}>{area}</li>
                        ))}
                    </ul>
                ) : (
                    <ul>
                        <li>No areas assigned to this region</li>
                    </ul>
                )}

            </ModalBody>
            <ModalFooter>
                <Button onClick={() => setIsAreaModalOpen(false)}>Close</Button>
            </ModalFooter>
        </Modal>
    );

    const renderDeleteModal = () => (
        <Modal
            isOpen={isDeleteModalOpen}
            toggle={() => setIsDeleteModalOpen(false)}
            centered
        >
            <ModalHeader>
                Confirm Delete
            </ModalHeader>
            <ModalBody>
                Are you sure you want to delete the area "
                {selectedAreaToDelete?.Location ? selectedAreaToDelete?.Location : selectedAreaToDelete.areaName}"?
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={confirmDelete}>
                    Yes, Delete
                </Button>
                <Button onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
    const renderEditModal = () => (
        <Modal
            isOpen={isEditModalOpen}
            toggle={() => setIsEditModalOpen(false)}
            centered
        >
            <ModalHeader>
                Edit Region
            </ModalHeader>
            <ModalBody>
                <Card
                    style={{
                        backgroundColor: STYLES.PRIMARY_APP_CLR,
                        width: "95%",
                        height: "100%",
                    }}
                >
                    <CardHeader>
                        <CardTitle tag="h4" style={{ color: "white" }}>
                            Region Details
                        </CardTitle>
                    </CardHeader>
                    <CardBody>
                        <form onSubmit={handleUpdateSubmit}>
                            <FormText color="white" tag="span">Region Name:</FormText>
                            <Input
                                type="text"
                                name="RegionName"
                                value={editRegionData?.regionName}
                                onChange={(e) =>
                                    setEditRegionData({ ...editRegionData, regionName: e.target.value })
                                }
                                required
                                style={{
                                    borderWidth: 2,
                                    borderColor: STYLES.TERTIARY_APP_CLR,
                                    height: 40,
                                    backgroundColor: "white",
                                    fontSize: 16,
                                    paddingHorizontal: 10,
                                    paddingVertical: 8,
                                    borderRadius: 8,
                                    color: "grey",
                                    paddingRight: 30,
                                }}
                            />

                            <GridItem xs={12} sm={12} md={12} lg={12}>
                                <GridContainer spacing={1}>
                                    <GridItem xs={12}>
                                        <FormText>Branch:</FormText>
                                        {branchList && branchList.length > 0 ? (
                                            <CustomDropDownPicker
                                                options={branchList}
                                                isMulti={false}
                                                value={editRegionData?.selectedBranchName}
                                                onChange={(value) => {
                                                    let selectedBranch = branchList.find(branch => branch.value === value);
                                                    setEditRegionData({ ...editRegionData, selectedBranchName: selectedBranch.label })
                                                    console.log(`Branch: ${selectedBranch.label}`)
                                                }}
                                            />
                                        ) : (
                                            <FormText color="grey">No branches available</FormText> // Fallback if no branches
                                        )}
                                    </GridItem>
                                </GridContainer>
                                {/* <GridContainer spacing={1}>
                                    <GridItem xs={12}>
                                        <FormText>Brokers:</FormText>
                                        {brokerList && brokerList.length > 0 ? (
                                            <CustomDropDownPicker
                                                options={brokerList}
                                                isMulti={true}
                                                value={editRegionData?.shareBrokers}
                                                onChange={(value) => {
                                                    let selectedBroker = brokerList.find(broker => broker.value === value);
                                                    setEditRegionData({ ...editRegionData, shareBrokers: value })
                                                    //console.log(`Brokers: ${selectedBroker.label}`)
                                                }}
                                            />
                                        ) : (
                                            <FormText color="grey">No branches available</FormText> // Fallback if no branches
                                        )}
                                    </GridItem>
                                </GridContainer> */}
                            </GridItem>

                            <ModalFooter>
                                <Button
                                    type="submit"
                                    style={{ backgroundColor: STYLES.PRIMARY_BUTTON_CLR, color: "white" }}

                                >
                                    Update
                                </Button>
                                <Button
                                    onClick={() => setIsEditModalOpen(false)}
                                    style={{ backgroundColor: STYLES.TERTIARY_APP_CLR, color: "white" }}
                                >
                                    Cancel
                                </Button>
                            </ModalFooter>
                        </form>
                    </CardBody>
                </Card>
            </ModalBody>
        </Modal>
    );

    return (
        <>
            <div>
                <CreateRegionModal />

                {successMessage && (
                    <div style={{ color: "green", marginTop: "10px" }}>
                        {successMessage}
                    </div>
                )}

                {isEditModalOpen ? renderEditModal() : null}
                {isDeleteModalOpen ? renderDeleteModal() : null}
                {isAreaModalOpen ? renderAreasModal() : null}
            </div>

            <Row>
                <Card
                    style={{
                        backgroundColor: STYLES.PRIMARY_APP_CLR,
                        width: "100%",
                        height: "20%",
                    }}
                >
                    <CardHeader>
                        <CardTitle tag="h4" style={{ color: "white" }}>
                            Region Table
                        </CardTitle>
                    </CardHeader>
                    <CardBody>
                        <MaterialTable
                            title={"Regions"}
                            columns={[
                                {
                                    title: "Region Name",
                                    field: "regionName",
                                    render: (rowData) => (
                                        <Button
                                            color="white"
                                            onClick={() => {
                                                navigate("/regioninfo", { state: rowData });
                                            }} // Pass region data
                                        >
                                            {rowData.regionName}
                                        </Button>
                                    )

                                },
                                {
                                    title: "Branch Name",
                                    field: "selectedBranchName"
                                },

                                {
                                    title: "Areas",
                                    field: "areas",
                                    render: (rowData) => (
                                        <Button
                                            color="white"
                                            onClick={() => {
                                                handleAreasClick(rowData);
                                                setIsAreaModalOpen(true);
                                            }}
                                        >
                                            areas
                                        </Button>
                                    )

                                },

                                {
                                    title: "Actions",
                                    render: (rowData) => (
                                        <>
                                            <Button
                                                color="warning"
                                                onClick={() => handleEditClick(rowData)}
                                            >
                                                Edit
                                            </Button>
                                            {/* <Button
                                                color="danger"
                                            //onClick={() => handleDeleteClick(rowData)}
                                            >
                                                Delete
                                            </Button> */}
                                        </>
                                    ),
                                },
                            ]}
                            data={regions}
                            // Use the fetched branches data
                            options={{
                                sorting: true,
                                search: true,
                                paging: true,
                            }}
                        />
                    </CardBody>
                </Card>
                {/* Statistics Card */}

            </Row>
        </>
    );
};

export default regionManagement;
